import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminProtectedRoute = ({ children }) => {
  const { isAdmin,authLoading } = useContext(AuthContext);
  return authLoading?<div>Loading...</div>:(isAdmin ? children : <Navigate to="/admin_login" />);
};

export default AdminProtectedRoute;

